import type { Theme } from '@mui/material/styles';
import type { CSSObject } from 'styled-components';

import type { ChipProps } from './Chip.types';

export const generateChipCss = (theme: Theme, props: ChipProps): CSSObject => {
  const { variant, size, chipColor } = props;

  // Base styles
  const baseStyles: CSSObject = {
    borderRadius: '4px',
    width: 'fit-content',
    gap: '4px',
  };

  const colorMap = {
    purple: {
      backgroundColor: theme.new.color.purple[200],
      color: theme.new.color.purple[600],
    },
    'brand-blue': {
      backgroundColor: theme.new.color.brand[200],
      color: theme.new.color.brand[600],
    },
    grey: {
      backgroundColor: theme.new.color.grey[100],
      color: theme.new.color.textSecondary,
    },
    green: {
      backgroundColor: theme.new.color.success[100],
      color: theme.new.color.success[600],
    },
    red: {
      backgroundColor: theme.new.color.danger[100],
      color: theme.new.color.danger[600],
    },
    yellow: {
      backgroundColor: theme.new.color.warning[100],
      color: theme.new.color.warning[700],
    },
    white: {
      backgroundColor: theme.new.color.common.white,
      color: theme.new.color.textSecondary,
    },
  };

  const chipColorConfig = colorMap[chipColor || 'white'];
  const colorStyles: CSSObject = {
    ...(variant === 'outlined' && {
      backgroundColor: chipColorConfig.backgroundColor,
      color: chipColorConfig.color,
      border: `1px solid ${chipColorConfig.color}`,
    }),
    ...(variant === 'filled' && {
      backgroundColor: chipColorConfig.color,
      color: theme.new.color.common.white,
    }),
  };
  // Size variants
  const sizeStyles: CSSObject = {
    ...(size === 'small' && {
      height: 20,
      padding: '2px 4px',
      // Apply specific typography variant to all chip labels
      '& .MuiChip-label': {
        ...(theme.typography.caption_medium as CSSObject), // Using caption_medium variant
      },
    }),

    ...(size === 'large' && {
      height: 40,
      padding: '4px 8px',
      // Apply specific typography variant to all chip labels
      '& .MuiChip-label': {
        ...(theme.typography.body_medium as CSSObject), // Using caption_medium variant
      },
    }),
  };

  return {
    ...baseStyles,
    ...colorStyles,
    ...sizeStyles,
  };
};
